var map = {
	"./current/logo-new.png": 145,
	"./current/logo.png": 146,
	"./default/chat-bubble 2.png": 147,
	"./default/chat-bubble.png": 148,
	"./paintedtree/logo-new.png": 145,
	"./paintedtree/logo.png": 146,
	"./regencyattentrails/logo.png": 339,
	"./sundancenorthlife/logo.png": 340,
	"./viridian/chat-bubble.png": 341,
	"./viridian/logo-new.png": 342,
	"./viridian/logo.png": 343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 144;